module.exports = __webpack_public_path__ + "a298461063fc5b24a26f86fdf9c6c3e7.png";